import React from 'react';

const About = () => {
  return (
    <div className="App-intro App-about">
      <h2>Hi</h2>
      I am Avdhesh Garodia
    </div>
  )
}

export default About;



// WEBPACK FOOTER //
// ./src/About.js